import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import InputMask from "react-input-mask";

import Config from "config";
const ExportComptable = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("auth_token_" + api);
  const [pmeData, setPmeData] = useState();
  const [pmeDataOptions, setPmeDataOptions] = useState({
    data: [],
  });
  const [selectedPmeData, setSelectedPmeData] = useState({
    label: "Toutes les sociétés",
    value: null,
  });
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);

  const colStyle = { width: "10em", whiteSpace: "nowrap" };

  const [numPMEs, setNumPMEs] = useState("");
  const [firstNumber, setFirstNumber] = useState("");
  const [loading, setLoading] = useState(true);
  const [firstDate, setFirstDate] = useState("");
  const [secondDate, setSecondDate] = useState("");

  const [activeTab, setActiveTab] = useState("details");

  const renderPmeOptions = () => {
    return [
      {
        options: pmeDataOptions.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePmeChange = (e) => {
    setSelectedPmeData(e);
  };
  // Export
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [downloadUrl1, setDownloadUrl1] = useState(null);
  const [downloadUrl2, setDownloadUrl2] = useState(null);
  const downloadLinkRef = useRef(null);
  const downloadLinkRef1 = useRef(null);
  const downloadLinkRef2 = useRef(null);

  const ExportDossier = async (event) => {
    event.preventDefault();
    setLoading2(true);
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/pmes/export_comptable`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            pme: {
              pme_id: selectedPmeData?.value,
              start_at: firstDate,
              end_at: secondDate,
              export: "export_dossier",
            },
          }),
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        setDownloadUrl(url);
        console.log("request successful");
      } else {
        console.error(" request failed");
        const responseData = await response.json();

        if (responseData && responseData.pme_validation) {
          const errors = responseData?.pme_validation;
          errors.forEach((error) => {
            console.error(error);
          });
        } else {
          console.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      console.error("Une erreur s'est produite");
    } finally {
      setLoading2(false);
    }
    // }
  };
  const ExportActionnaire = async (event) => {
    event.preventDefault();
    setLoading3(true);
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/pmes/export_comptable`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            pme: {
              pme_id: selectedPmeData.value,
              start_at: firstDate,
              end_at: secondDate,
              export: "export_actionnaire",
            },
          }),
        }
      );

      if (response.ok) {
        console.log("request successful");
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        setDownloadUrl1(url);
      } else {
        console.error(" request failed");
        const responseData = await response.json();

        if (responseData && responseData.pme_validation) {
          const errors = responseData?.pme_validation;
          errors.forEach((error) => {
            console.error(error);
          });
        } else {
          console.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      console.error("Une erreur s'est produite");
    } finally {
      setLoading3(false);
    }
    // }
  };
  const ExportOperation = async (event) => {
    event.preventDefault();
    setLoading4(true);
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/pmes/export_comptable`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            pme: {
              pme_id: selectedPmeData.value,
              start_at: firstDate,
              end_at: secondDate,
              export: "export_operation",
            },
          }),
        }
      );

      if (response.ok) {
        console.log("request successful");
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        setDownloadUrl2(url);
      } else {
        console.error(" request failed");
        const responseData = await response.json();

        if (responseData && responseData.pme_validation) {
          const errors = responseData?.pme_validation;
          errors.forEach((error) => {
            console.error(error);
          });
        } else {
          console.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      console.error("Une erreur s'est produite");
    } finally {
      setLoading4(false);
    }
    // }
  };
  useEffect(() => {
    setLoading(true);

    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const pmeData = await response.json();
        setPmeData(pmeData);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };
    const getPME = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/pmes/pmes`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const pmeData = await response.json();
        setPmeDataOptions(pmeData);
        const newOption = { label: "Toutes les sociétés", value: null };
        setPmeDataOptions((prevOptions) => ({
          data: [newOption, ...prevOptions.data],
        }));
        if (id) {
          console.log(pmeData?.data)
          console.log(id)
          const foundPme = pmeData?.data.find(item => item.id == id);
          console.log(foundPme)
          if (foundPme) {
            setSelectedPmeData({ label: foundPme.label, value: foundPme.id });
          }
        }
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        if (id) {
          await getData();
        }
        await getPME();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const newOption = { label: "Toutes les sociétés", value: null };

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (downloadUrl && downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  }, [downloadUrl]);
  useEffect(() => {
    if (downloadUrl1 && downloadLinkRef1.current) {
      downloadLinkRef1.current.click();
    }
  }, [downloadUrl1]);
  useEffect(() => {
    if (downloadUrl2 && downloadLinkRef2.current) {
      downloadLinkRef2.current.click();
    }
  }, [downloadUrl2]);

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Export Comptable
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Logique pour gérer la soumission du formulaire, par exemple, envoyer les données au serveur
    console.log("Données soumises :", {
      pmeToClone,
      numPMEs,
      rootName,
      firstNumber,
    });
  };
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={ id ? `${backUrl}/pmes/${id}` : `${backUrl}/pmes`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        PME
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        pmeData?.sil || "Export comptable"
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end"></div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Row>
                              <Col xs={12} md={12} lg={4} style={colStyle}>
                                <i
                                  style={{
                                    color: "#9d9c9c",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "11em",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    PME :
                                  </span>
                                </i>
                              </Col>
                              <Col className="mb-2 col-md-3">
                                <Select
                                  value={selectedPmeData}
                                  onChange={handlePmeChange}
                                  options={renderPmeOptions()}
                                  isClearable={true}
                                  className="select2"
                                />
                              </Col>
                              <Col className="mb-2 col-md-3">
                                <button
                                  onClick={ExportDossier}
                                  className="btn btn-sm btn-primary"
                                  disabled={loading2}
                                >
                                  {loading2
                                    ? "Export en cours..."
                                    : "Export dossiers sociétés"}
                                </button>

                                {downloadUrl && (
                                  <a
                                    href={downloadUrl}
                                    download="Dossier.xlsx"
                                    ref={downloadLinkRef}
                                    style={{ display: "none" }}
                                  >
                                    Télécharger le fichier excel
                                  </a>
                                )}
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={12} lg={4} style={colStyle}>
                                <i
                                  style={{
                                    color: "#9d9c9c",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "11em",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    Début :
                                  </span>
                                </i>
                              </Col>
                              <Col className="mb-2 col-md-3">
                                <InputMask
                                  mask="99/99/9999"
                                  value={firstDate}
                                  className="form-control input-color"
                                  onChange={(e) => setFirstDate(e.target.value)}
                                />
                              </Col>
                              
                              {selectedPmeData?.value && (
                                <Col className="mb-2 col-md-3">
                                <button
                                  onClick={ExportActionnaire}
                                  className="btn btn-sm btn-primary"
                                  disabled={loading3}
                                >
                                  {loading3
                                    ? "Export en cours..."
                                    : "Export actionnaires"}
                                </button>

                                {downloadUrl1 && (
                                  <a
                                    href={downloadUrl1}
                                    download={`actionnaire_${selectedPmeData?.label}_${Date.now()}.txt`}
                                    ref={downloadLinkRef1}
                                    style={{ display: "none" }}
                                  >
                                    Télécharger le fichier txt
                                  </a>
                                )}
                                </Col>
                              )}
                            </Row>
                            <Row>
                              <Col xs={12} md={12} lg={4} style={colStyle}>
                                <i
                                  style={{
                                    color: "#9d9c9c",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "11em",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    Fin :
                                  </span>
                                </i>
                              </Col>
                              <Col className="mb-2 col-md-3">
                                <InputMask
                                  mask="99/99/9999"
                                  value={secondDate}
                                  className="form-control input-color"
                                  onChange={(e) =>
                                    setSecondDate(e.target.value)
                                  }
                                />
                              </Col>
                              {selectedPmeData?.value && (
                                <Col className="mb-2 col-md-3">
                                  <button
                                    onClick={ExportOperation}
                                    className="btn btn-sm btn-primary"
                                    disabled={loading4}
                                  >
                                    {loading4
                                      ? "Export en cours..."
                                      : "Export opérations"}
                                  </button>

                                  {downloadUrl2 && (
                                    <a
                                      href={downloadUrl2}
                                      download={`operations_${selectedPmeData?.label}_${firstDate && secondDate ? `${firstDate}_${secondDate}` : Date.now().toString()}.xlsx`}
                                      ref={downloadLinkRef2}
                                      style={{ display: "none" }}
                                    >
                                      Télécharger le fichier excel
                                    </a>
                                  )}
                                </Col>
                              )}
                            </Row>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default ExportComptable;
